import type { Component } from 'vue';
import SimpleTab from './SimpleTab.vue';
import SimpleTabs from './SimpleTabs.vue';

export default new Map<string, Component>([
  ['SimpleTab', SimpleTab],
  ['SimpleTabs', SimpleTabs],
]);

